import { CustomBox } from "components";
import { ChurnRateIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends, getUserRate } from "../../helpers";

export function ChurnRate({ data, isLoading, totalUsers }: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#1C1C1D"
      title="Churn Rate"
      userCount={getUserRate({ value: total, total: totalUsers?.total }) + "%"}
      boxData={{
        label: "User Churn",
        description:
          "The percentage of users who cancel or do not renew their subscription.",
        todayCount:
          getUserRate({ value: today, total: totalUsers?.today }) + "%",
        weekCount:
          getUserRate({ value: thisWeek, total: totalUsers?.thisWeek }) + "%",
        monthCount:
          getUserRate({ value: thisMonth, total: totalUsers?.thisMonth }) + "%",
        yearCount:
          getUserRate({ value: thisYear, total: totalUsers?.thisYear }) + "%",
        icon: ChurnRateIcon,
      }}
      percentages={growthTrends}
    />
  );
}
